import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import c from '../../../components/commonStyle.css';
import rdp from '!isomorphic-style-loader!css-loader!sass-loader!react-day-picker/lib/style.css';
import s from '!isomorphic-style-loader!css-loader!sass-loader!./MonthlyPassStartDayPicker.css';

import cx from 'classnames';

import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

// Redux
import { connect } from 'react-redux';

// Redux Action
//import { checkAvailability } from '../../../actions/checkAvailability';

// Redux Form
import { change, formValueSelector } from 'redux-form';

import { CHECK_AVAILABLE_DATES_SUCCESS } from '../../../constants';

// Translation
import { injectIntl } from 'react-intl';

// Locale
//import messages from '../../../locale/messages';

//Helper
//import { isRTL } from '../../../helpers/formatLocale';
//import { getDateUsingTimeZone } from '../../../helpers/dateRange';
//import { dateFormat } from '../../../config';

class MonthlyPassStartDayPicker extends React.Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    isOpenOnWeekends: PropTypes.bool.isRequired,
    smallDevice: PropTypes.bool.isRequired,
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDay: undefined
    };
  }

  handleDayClick = (day, modifiers = {}) => {
    if( modifiers.disabled ) {
      return;
    }

    this.setState({
      selectedDay: modifiers.selected ? undefined : day
    });

    this.handleAsyncOperations(moment(day));
  }

  async handleAsyncOperations(startDate) {
    const { formName, change, dispatch } = this.props;
    
    await change(formName, 'startDate', startDate);

    await dispatch({
      type: CHECK_AVAILABLE_DATES_SUCCESS,
      isLoading: false,
      availability: true,
      payload: {
        maximumStay: false,
        minimumStay: false,
        closedOnWeekends: false
      }
    });
  }

  render() {
    const { isOpenOnWeekends, locale } = this.props;
    const { selectedDay } = this.state;

    //Move to componentDidMount()?
    let placeholderDate = new Date();
    while( !isOpenOnWeekends ) {
      if( ![0,6].includes(placeholderDate.getDay())) {
        break;
      }
      placeholderDate.setDate(placeholderDate.getDate() + 1);
    }
    let placeholder = formatDate(placeholderDate, 'L', locale);
    //

    let endDate = new Date();
    let daysCount = 0;
    while( true ) {
      endDate.setDate(endDate.getDate() + 1);
      if( !isOpenOnWeekends || ![0,6].includes(endDate.getDay()) ) {
        ++daysCount;
      }
      if( daysCount >= 6 ) break;
    }

    return (
      <div className={'SelectedMonth'}>
        <DayPickerInput
          /* classNames={{container: 'input__SelectedMonth',
                       overlay: 'DayPicker-Overlay'}} */
          component={props => <input className={cx(c.commonControlInput, c.fullWidth)} {...props} />}
          formatDate={formatDate}
          parseDate={parseDate}
          format={'L'}
          placeholder={placeholder}
          /* showOverlay={true} */
          dayPickerProps={{
            numberOfMonths: 1,
            firstDayOfWeek: 1,
            locale: locale,
            localeUtils: MomentLocaleUtils,
            selectedDays: selectedDay,
            showOutsideDays: true,
            onDayClick: this.handleDayClick,
            disabledDays: [DateUtils.isPastDay, ...!isOpenOnWeekends ? [{daysOfWeek: [0, 6]}] : [], (day) => DateUtils.isDayAfter(day, endDate)],
          }}
        />
      </div>
    );
  }
}

//const bookingFormSelector = formValueSelector('BookingForm');

const mapState = state => ({
  locale: state.intl.locale
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(c, s, rdp)(connect(mapState, mapDispatch)(MonthlyPassStartDayPicker)));



// WEBPACK FOOTER //
// src/components/ViewListing/MonthlyPassStartDayPicker/MonthlyPassStartDayPicker.js